module.exports = __webpack_public_path__ + "media/images/emblems/Hauteville-coat_of_arms-8fa772f5be9369b09d91ead78acb8e81.svg";